module.exports = __webpack_public_path__ + "static/media/breakfast_icon.b1fb8d82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/breakfast_icon.svg
// module id = 56
// module chunks = 0